import {ErrorEvent} from '../../../api/network';
import {IMCDropChannelResponse, MCDropChannelResponse} from '../../../api/proto';
import i18n from '../../../i18n';

export default function getDropChannelError(res?: IMCDropChannelResponse | null): ErrorEvent | null {
  if (res?.result === MCDropChannelResponse.Result.R_OK) {
    return null;
  }

  if (res?.result === MCDropChannelResponse.Result.R_CHANNEL_NOT_FOUND) {
    return new ErrorEvent({message: i18n.t('api_channel_drop_channel_not_found')});
  } else if (res?.result === MCDropChannelResponse.Result.R_INTERNAL_SERVER_ERROR) {
    return new ErrorEvent({message: i18n.t('api_channel_drop_internal_server_error')});
  }

  return new ErrorEvent({message: i18n.t('api_channel_drop_unknown_error')});
}